import { render, staticRenderFns } from "./RegisterThemes.vue?vue&type=template&id=fd16252c&scoped=true&"
import script from "./RegisterThemes.vue?vue&type=script&lang=js&"
export * from "./RegisterThemes.vue?vue&type=script&lang=js&"
import style0 from "./RegisterThemes.scss?vue&type=style&index=0&id=fd16252c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd16252c",
  null
  
)

export default component.exports